export const APP_SHORTCUTS = {
  boxLevelUI: (actions) => [
    {
      action: actions.toggleNewBox,
      ctrlOrMeta: true,
      key: 'b',
    },
  ],
};
